<template>
    <div>
        <div slot="title">
            <div class="title-view-control">
                <!-- Title !-->
                <h2 ref="titleElement">{{ title }} <span style="font-size: 1rem;">&#9660;</span>

                    <!-- Filter Options Dropdown !-->
                    <ui-popover 
                        v-show="$refs.titleElement"
                        :trigger="$refs.titleElement" 
                        ref="titlePopover"
                        class="drop-popover left-marker"
                        dropdown-position="bottom left"
                        :raised="false"
                    >
                        <div class="dropdown-menu show" aria-labelledby="dropdownMenuLink" style="overflow-y: auto; max-height: 60vh;">
                            <span
                                    v-for="option in options"
                                    :class="getMenuItemClass(option)"
                                    @click="select(option)"
                                    :style="'cursor: pointer;' + (option.type === 'divider' ? 'display:block;' : '')">

                                <span v-if="option.nested">- </span>{{ option.label }}
                                <span v-if="option.type === 'subtitle' && option.configurable" class="material-icons" style="float: right; font-size: 1rem;">settings</span>
                            </span>
                        </div>
                    </ui-popover>
                </h2>

                <!-- Save Custom View !-->
                <a v-if="isCustomView" href="#" @click.prevent="save" class="pill pill-dark pill-sm" style="vertical-align: top; margin-left: 1rem;"><span class="material-icons">save</span></a>

                <!-- Saved View Option Button !-->
                <a v-if="isSavedView" ref="optionButton" href="#" @click.prevent="$emit('settings')" class="pill pill-dark pill-sm" style="vertical-align: top; margin-left: 1rem;"><span class="material-icons">settings</span>
                    <!-- Saved View Options Menu !-->
                    <ui-popover 
                        ref="viewPopover"
                        v-if="$refs.optionButton"
                        :trigger="$refs.optionButton" 
                        class="drop-popover left-marker"
                        dropdown-position="bottom left"
                        :raised="false"
                    >
                        <div class="dropdown-menu show" aria-labelledby="dropdownMenuLink"">
                            <h6 class="dropdown-header">View Options</h6>
                            <span @click="edit(savedViewId); $refs.viewPopover.close()" class="dropdown-item" style="cursor: pointer;">
                                Rename
                            </span>
                            <span @click="deleteView(savedViewId); $refs.viewPopover.close()" class="dropdown-item" style="cursor: pointer;">
                                Delete
                            </span>
                        </div>
                    </ui-popover>
                </a>

                <!-- DataView Modal !-->
                <save-data-view-modal ref="viewModal"></save-data-view-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import SaveDataViewModal from './SaveDataViewModal'
    import { mapState, mapActions } from 'vuex'

    export default {
        components: {
            SaveDataViewModal
        },
        props: {
            title: {
                type: String,
                default: 'Untitled',
            },
            options: {
                type: Array,
                default: [],
            },
        },
        computed: {
            ...mapState({
                isCustomView: state => state.dataView.isCustomView,
                isSavedView: state => state.dataView.isSavedView,
                savedViewId: state => state.dataView.savedViewId,
            })
        },
        methods: {
            ...mapActions({
                deleteView: 'dataView/delete',
            }),
            save() {
                this.$refs['viewModal'].open();
            },
            edit() {
                this.$refs['viewModal'].open(this.savedViewId);
            },
            getMenuItemClass(option) {
                if (option.type === 'subtitle') {
                    return 'dropdown-header'
                } else if (option.type === 'divider'){
                    return 'dropdown-divider'
                }

                return 'dropdown-item'
            },
            select(option) {
                if (option.href) {
                    window.location = option.href;
                }

                this.$emit('select', option);

                this.$refs.titlePopover.close();

                if ("activeElement" in document)
                    document.activeElement.blur();
            },
        }
    }
</script>